/**
 * Constants used throughout the application
 */
export const ConstVariables = {
  testNetworkImg: "https://firebasestorage.googleapis.com/v0/b/getxcommerce.appspot.com/o/%D8%B3%D9%88%D9%82%20%D8%A7%D9%84%D8%A7%D8%B1%D8%AF%D9%86%20icon.png?alt=media&token=130d92cf-3df1-47a4-95e0-8b2b3b895ea6",

  devicesTypeList: [
    'Apple',
    'Samsung',
    'Sony',
    'Special Number',
    'Home & Kitchen Appliances',
    'BlcakBerry',
    'Canon',
    'LG',
    'Nokia',
    'Microsoft',
    'Nikon',
    'HTC',
    'Toshiba',
    'DELL',
    'Huawei',
    'Asus',
    'Acer',
    'Panasonic',
    'Fujifilm',
    'Hitachi',
    'Olympus',
    'Computers',
    'Gaming',
    'TV & Audio',
    'Generator',
    'Account and Subscription',
    'Digital Camera',
    'Uncategorized Devices',
  ],
  
  othersTypeList: [
    'Animals, Livestock and birds',
    'Furniture',
    'Personal Accessories',
    "Services",
    'Jobs',
    'Missing',
    'Food and beverages',
    'Games and Entertainment',
    'Hunting and trips',
    'Cultivation and Gardens',
    'Programming and designs',
    'Parties and events',
    'Library and Arts',
    'Traver and Tourism',
    'Education and training',
    'Financing and loans',
    'Anecdotes and Traditions',
    'Projects and investments',
    "Uncategorized section",
  ],

  animalsModelsList: [
    'Sheep',
    'Goats',
    'Parrot',
    "Pigeons",
    'Cats',
    'Chicken',
    'Camels',
    'Horses',
    'Dogs',
    'Cows',
    'Fish and turtles',
    'Rabbits',
    'Duck',
    'Squirrels',
    'Hamsters',
    'Hyrax',
  ],
  
  furnitureList: [
    'Outdoor furniture',
    'Office furniture',
    'Houseware',
    "Beds and mattresses",
    'Antiques and decor',
    'Cabinets and cupboards',
    'tables and chairs',
    'Sofas and furnishings'
  ],

  personalAccessoriesList: [
    'Watches',
    'Perfumes',
    'Sports accessories',
    'Glassess',
    'Man Clothes',
    'kids Clothes',
    'Women\'s fashion',
    'Gifts',
    'Luggage',
    'Health and beauty'
  ],
  
  servicesList: [
    'Construction services',
    'Agent services',
    'Delivery services',
    'Furniture Transfering services',
    'Cleaning services',
    'Buying from foregin websites services',
    'real estate services',
    'legal services',
    'Accounting and financial services',
    'Other services',
  ],
  
  jobsList: [
    'Administrative functions',
    'Costumes and beauty jobs',
    'security and safety jobs',
    'Educational functions',
    'Technical and design functions',
    'Agricultural and grazing functions',
    'Industrial Jobs',
    'Jobs Medical and Nursing',
    'Building jobs',
    'Home employment jobs',
    'Restaurants jobs',
  ],

  foodAndBeveragesList: ['Food And Beverages'],
  
  gamesAndEntertainmentList: [
    'Games And Entertainment'
  ],
  
  huntingAndTripsList: ['Hunting And Trips'],
  
  cultivationAndGardensList: [
    'Cultivation And Gardens'
  ],
  
  programmingAndDesignList: [
    'Programming And Design'
  ],
  
  partiesAndEventsList: ['Parties And Events'],
  
  libraryAndArtsList: ['Library And Arts'],
  
  travelAndTourismList: [
    'roommate',
    'Serviced Apartments'
  ],
  
  missingList: ['missing'],
  
  educationAndTrainingList: [
    'Electronic Games Training',
    'Sports Exercices',
    'Education shares and currencies',
    'Leading',
    'Private classes',
    'Training courses'
  ],
  
  financingAndLoansList: ['Financing And Loans'],
  
  anecdotesAndTraditionsList: [
    'Anecdotes And Traditions'
  ],
  
  projectsAndInvestmentList: [
    'Projects And Investments'
  ],
  
  uncategorizedList: ['Un categorized'],

  appleModelsList: [
    'Iphone',
    'Ipad',
    'MacBook',
    "Ipod",
    'Apple Watch'
  ],

  unCategorizedModelsList: ['Uncategorized'],

  samsungModelsList: [
    'Galaxy S',
    'Galaxy Note',
    'Galaxy Tab',
    'Samsung Camera'
  ],

  sonyModelsList: [
    'PlayStation',
    'PlayStation Games',
    'Xperia phones',
    'Laptop',
    'Screens'
  ],
  
  specialNumbersList: [
    'From STC',
    'From Mobily',
    'From Zain',
  ],

  homeKitchenList: [
    'Cooker and oven',
    'Refrigerators',
    'Mixers',
    'washing machine',
    'boiler',
    'frying pan',
    'Coffee machine',
    'Microwave and Toasters',
    'Vacuum Cleaner',
    'Iron',
    'Air Conditioner',
    'Other home appliances',
  ],

  blackBerryModelsList: ['BlackBerry'],
  canonModelsList: ['Canon'],
  lgModelsList: ['LG'],
  nokiaModelsList: ['NOKIA'],
  nikonModelsList: ['Nikon'],
  htcModelsList: ['HTC'],
  toshibaModelsList: ['Toshiba'],
  dellModelsList: ['DELL'],
  huaweiModelsList: ['Huawei'],
  asusModelsList: ['Asus'],
  acerModelsList: ['Acer'],
  panasonicModelsList: ['Panasonic'],
  hitachiModelsList: ['Hitachi'],
  olympusModelsList: ['Olympus'],
  gamingModelsList: ['Gaming'],
  generatorsModelsList: ['Generators'],
  
  accountsAndSubscriptionsModelsList: [
    'Pubg',
    'Fortnite',
    'FIFA',
    'Clash pf Clans',
    'Clash Royale',
    'instagram accounts',
    'Twitter accounts',
    'Tik Tok accounts',
    'Snapchat accounts',
    'Facebook accounts',
    'Youtube accounts',
    'Other Accounts'
  ],
  
  tvAndAudioModelsList: ['TV', 'Receivers', 'Audio'],
  
  digitalCameraModelsList: [
    'Drones',
    'Lenses',
    'Cameras',
    'Camera Accessories'
  ],
  
  computersModelsList: [
    'Networking',
    'Displays & Projectors',
    'Printers & scanners',
    'PC',
    'Laptops',
    'Computer Accessories'
  ],
  
  fujifilmModelsList: ['Fujifilm'],
  
  microsoftModelsList: [
    'Xbox Games',
    'Xbox',
    'Surface'
  ],

  toyotaCarModels: [
    'Toyota 4Runner',
    'Toyota Avalon',
    'Toyota Camry',
    'Toyota Corolla',
    'Toyota C-HR',
    'Toyota Highlander',
    'Toyota Land Cruiser',
    'Toyota Mirai',
    'Toyota Prius',
    'Toyota RAV4',
    'Toyota Sequoia',
    'Toyota Sienna',
    'Toyota Tacoma',
    'Toyota Tundra',
    'Toyota Yaris',
    'Toyota GR86',
    'Toyota Supra',
    'Toyota Hilux', // Note: available in certain markets
    'Toyota Venza',
    'Toyota Sienta', // Note: available in certain markets
  ],
  
  lexusCarModels: [
    'Lexus ES',
    'Lexus GS',
    'Lexus IS',
    'Lexus NX',
    'Lexus RX',
    'Lexus GX',
    'Lexus LX',
    'Lexus RC',
    'Lexus LC',
    'Lexus UX',
    'Lexus LS',
    'Lexus RZ', // Note: newer electric model
    'Lexus CT', // Note: discontinued in some markets
  ],
  
  hondaCarModels: [
    'Honda Accord',
    'Honda Civic',
    'Honda CR-V',
    'Honda HR-V',
    'Honda Insight',
    'Honda Odyssey',
    'Honda Passport',
    'Honda Pilot',
    'Honda Ridgeline',
    'Honda Fit', // Note: discontinued in some markets
    'Honda S2000', // Note: discontinued
    'Honda Clarity', // Note: discontinued in some markets
    'Honda ZR-V', // Note: newer model in some markets
  ],
  
  mazdaCarModels: [
    'Mazda2',
    'Mazda3',
    'Mazda6',
    'Mazda CX-3',
    'Mazda CX-30',
    'Mazda CX-5',
    'Mazda CX-9',
    'Mazda MX-5 Miata',
    'Mazda MX-30', // Newer electric model
    'Mazda RX-7', // Discontinued
    'Mazda RX-8', // Discontinued
    'Mazda Tribute', // Discontinued
    'Mazda Millenia', // Discontinued
    'Mazda 3 Axela', // Name used in some markets
    'Mazda 5', // Discontinued
    'Mazda MPV', // Discontinued
    'Mazda B-Series' // Pickup trucks, discontinued
  ],
  carsTypeList:[
  "Toyota",
  "Hyundai",
  "Ford",
  "Kia",
  "Lexus",
  "Honda",
  "Mazda",
  "Chevrolet",
  "Parts & Accessories",
  "Nissan",
  "Geely",
  "Chery",
  "MG",
  "Genesis",
  "GMC",
  "Trucks and heavy equipment",
  "Mercedes",
  "BMW",
  "Motorcycles",
  "Dodge",
  "Chrysler",
  "Jeep",
  "Mitsubishi",
  "Isuzu",
  "Land Rover",
  "Cadillac",
  "Porsche",
  "Audi",
  "Suzuki",
  "Infinity",
  "Hummer",
  "Lincoln",
  "Volkswagen",
  "Daihatsu",
  "Mercury",
  "Volvo",
  "Peugeot",
  "Bentley",
  "Jaguar",
  "Subaru",
  "ZXAUTO",
  "Changan",
  "Renault",
  "Buick",
  "Maserati",
  "Rolls-Royce",
  "Lamborghini",
  "Ferrari",
  "Citroen",
  "Seat",
  "Saab",
  "Fiat",
  "SsangYong",
  "Aston Martin",
  "Proton",
  "Haval",
  "GAC",
  "Great Wall",
  "FAW",
  "BYD",
  "Alfa Romeo",
  "TATA",
  "JMC",
  "JETOUR",
  "CMC",
  "Foton",
  "VICTORY AUTO",
  "Lifan",
  "Maxus",
  "McLaren",
  "JAC",
  "Baic",
  "Dongfeng",
  "EXEED",
  "Tesla",
  "Lucid",
  "INEOS",
  "Soueast",
  "Mahindra",
  "Zotye",
  "Hongqi",
  "SMART",
  "Tank",
  "Lynk & Co",
  "Opel",
  "Skoda",
  "Daewoo"
],
  
  chevroletCarModels: [
    'Chevrolet Spark',
    'Chevrolet Sonic',
    'Chevrolet Malibu',
    'Chevrolet Camaro',
    'Chevrolet Corvette',
    'Chevrolet Impala', // Discontinued
    'Chevrolet Volt', // Discontinued
    'Chevrolet Bolt EV',
    'Chevrolet Trailblazer',
    'Chevrolet Equinox',
    'Chevrolet Traverse',
    'Chevrolet Tahoe',
    'Chevrolet Suburban',
    'Chevrolet Colorado',
    'Chevrolet Silverado 1500',
    'Chevrolet Silverado HD',
    'Chevrolet Blazer',
    'Chevrolet Astro', // Discontinued
    'Chevrolet HHR', // Discontinued
    'Chevrolet S10', // Discontinued
    'Chevrolet Caprice', // Discontinued
    'Chevrolet El Camino', // Discontinued
  ],
  
  nissanCarModels: [
    'Nissan Altima',
    'Nissan Maxima',
    'Nissan Sentra',
    'Nissan Versa',
    'Nissan 370Z',
    'Nissan GT-R',
    'Nissan Leaf', // Electric
    'Nissan Rogue',
    'Nissan Murano',
    'Nissan Pathfinder',
    'Nissan Armada',
    'Nissan Kicks',
    'Nissan Juke', // Discontinued in some markets
    'Nissan Frontier',
    'Nissan Titan',
    'Nissan Xterra', // Discontinued
    'Nissan NV Cargo', // Discontinued
    'Nissan Pulsar', // Discontinued in some markets
    'Nissan Qashqai', // Known as Rogue Sport in some markets
  ],

  cheryCarModels: [
    'Chery Tiggo 2',
    'Chery Tiggo 3',
    'Chery Tiggo 5',
    'Chery Tiggo 7',
    'Chery Tiggo 8',
    'Chery Arrizo 5',
    'Chery Arrizo 6',
    'Chery Arrizo GX',
    'Chery E5',
    'Chery E3',
    'Chery Omoda 5',
    'Chery Exeed TX',
    'Chery Exeed VX',
    'Chery QQ',
    'Chery QQ Ice Cream',
    'Chery Fulwin',
    'Chery M11',
    'Chery Tiggo 4',
    'Chery Tiggo 9',
    'Chery SQR',
    'Chery A1',
    'Chery A3'
  ],

  hyundaiModels: [
    "Sonata",
    "Elantra",
    'Accent',
    'Azera',
    'Sentavi',
    'Tucson',
    'Veloster',
    'Kona',
    'Creta',
    'Venue',
    'Palisade',
    'Grand Santa Fe',
    'Trajet',
    'Hyundai H1',
    'Staria',
    'Stragazer',
    'i40',
    'Centennial',
    'Coupe',
    'i10',
    'Veracruz',
    'Terracan',
    'Matrix',
    'Galloper',
    'i30'
  ],

  fordModels: [
    'Crown Victoria',
    'Grand Marquis',
    'Explorer',
    'Taurus',
    'Expedition',
    'Mustang',
    'Edge',
    'f150',
    'Territory',
    'Fusion',
    'Windstar',
    'Flex',
    'Fox',
    'Mondeo',
    'F250',
    'F350',
    'Ranger',
    'X Corgan',
    'Pick up',
    'Escape',
    'Splash',
    'Panther',
    'Thunderbird',
    'F450',
    'F550',
    'Escort',
    'Ecosport',
    'vansford',
    'Figo',
    'Bronco',
    'Everest'
  ],

  kiaModels: [
    'Cerato',
    'Rio',
    'Pegas',
    'Sportage',
    'Sorento',
    'Stinger',
    'Seltos',
    'Niro',
    'K5',
    'Sonet',
    'NS',
    'Telluride',
    'Optima',
    'Cadenza',
    'Carnival',
    'Opirus',
    'Cairns',
    'Picanto',
    'Mohave',
    'Corres',
    'Soul',
    'Sephia',
    'K900'
  ],
  
  mgCarModels: [
    'MG ZS',
    'MG ZS EV',
    'MG Hector',
    'MG Hector Plus',
    'MG Astor',
    'MG Gloster',
    'MG 6',
    'MG 3',
    'MG Cyberster',
    'MG Marvel R',
    'MG MG3',
    'MG MG6',
    'MG MG5',
    'MG MG ZS EV',
    'MG GS',
    'MG XPower',
    'MG EX234'
  ],

  genesisCarModels: [
    'Genesis G70',
    'Genesis G80',
    'Genesis G90',
    'Genesis GV70',
    'Genesis GV80',
    'Genesis Essentia',
    'Genesis Mint',
    'Genesis G80 Electrified',
    'Genesis GV60'
  ],

  gmcCarModels: [
    'GMC Sierra 1500',
    'GMC Sierra HD',
    'GMC Canyon',
    'GMC Terrain',
    'GMC Acadia',
    'GMC Yukon',
    'GMC Yukon XL',
    'GMC Savana',
    'GMC Hummer EV',
    'GMC Hummer H2',
    'GMC Envoy',
    'GMC Jimmy',
    'GMC Sierra Denali',
    'GMC Terrain Denali'
  ],

  truckAndHeavyEquipmentModels: [
    'Ford F-Series',
    'Chevrolet Silverado',
    'Ram 1500',
    'Toyota Tundra',
    'Nissan Titan',
    'GMC Sierra',
    'Freightliner Cascadia',
    'Kenworth T680',
    'Peterbilt 579',
    'Mack Anthem',
    'International LT Series',
    'Volvo VNL Series',
    'CAT 797F (Dump Truck)',
    'CAT D11 (Bulldozer)',
    'Komatsu PC8000 (Excavator)',
    'John Deere 744L (Wheel Loader)',
    'Hitachi ZW370 (Wheel Loader)',
    'Case CX250D (Excavator)',
    'Bobcat E165 (Excavator)',
    'JCB 3CX (Backhoe Loader)',
    'Caterpillar 320 (Excavator)'
  ],

  mercedesCarModels: [
    'Mercedes-Benz A-Class',
    'Mercedes-Benz B-Class',
    'Mercedes-Benz C-Class',
    'Mercedes-Benz E-Class',
    'Mercedes-Benz S-Class',
    'Mercedes-Benz GLA',
    'Mercedes-Benz GLB',
    'Mercedes-Benz GLC',
    'Mercedes-Benz GLE',
    'Mercedes-Benz GLS',
    'Mercedes-Benz G-Class',
    'Mercedes-Benz CLA',
    'Mercedes-Benz CLS',
    'Mercedes-Benz SL-Class',
    'Mercedes-Benz SLC-Class',
    'Mercedes-AMG GT',
    'Mercedes-AMG A45',
    'Mercedes-AMG C63',
    'Mercedes-AMG E63',
    'Mercedes-Maybach S-Class'
  ],
  
  bmwCarModels: [
    'BMW 1 Series',
    'BMW 2 Series',
    'BMW 3 Series',
    'BMW 4 Series',
    'BMW 5 Series',
    'BMW 6 Series',
    'BMW 7 Series',
    'BMW 8 Series',
    'BMW X1',
    'BMW X2',
    'BMW X3',
    'BMW X4',
    'BMW X5',
    'BMW X6',
    'BMW X7',
    'BMW Z4',
    'BMW i3',
    'BMW i4',
    'BMW iX',
    'BMW M2',
    'BMW M3',
    'BMW M4',
    'BMW M5',
    'BMW M8',
    'BMW X5 M',
    'BMW X6 M',
    'BMW X7 M'
  ],
  
  geelyCarModels: [
    'Geely Emgrand',
    'Geely Coolray',
    'Geely Azkarra',
    'Geely Atlas',
    'Geely Preface',
    'Geely Boyue',
    'Geely GC6',
    'Geely GC9',
    'Geely GE',
    'Geely Jingang',
    'Geely Binyue',
    'Geely Haoyue',
    'Geely Geometry A',
    'Geely Geometry C',
    'Geely Starlink',
  ],
  
  dodgeCarModels: [
    'Dodge Charger',
    'Dodge Challenger',
    'Dodge Durango',
    'Dodge Journey',
    'Dodge Viper',
    'Dodge Neon',
    'Dodge Dart',
    'Dodge Ram 1500',
    'Dodge Ram 2500',
    'Dodge Ram 3500',
    'Dodge Magnum',
    'Dodge Dakota',
    'Dodge Grand Caravan',
    'Dodge Avenger',
    'Dodge Intrepid',
  ],

  chryslerCarModels: [
    'Chrysler 300',
    'Chrysler Pacifica',
    'Chrysler Voyager',
    'Chrysler Aspen',
    'Chrysler Sebring',
    'Chrysler Town & Country',
    'Chrysler Crossfire',
    'Chrysler 200',
    'Chrysler Newport',
    'Chrysler Saratoga',
    'Chrysler PT Cruiser',
    'Chrysler Concorde',
    'Chrysler LeBaron',
    'Chrysler Imperial',
    'Chrysler Windsor',
  ],
  
  jeepModels: [
    "Jeep Wrangler",
    "Jeep Gladiator",
    "Jeep Cherokee",
    "Jeep Grand Cherokee",
    "Jeep Compass",
    "Jeep Renegade",
    "Jeep Wagoneer",
    "Jeep Grand Wagoneer",
    "Jeep Liberty", // Older model
    "Jeep Patriot", // Older model
    "Jeep CJ Series", // Classic models
    "Jeep Cherokee XJ", // Classic models
  ],
  
  mitsubishiModels: [
    "Mitsubishi Outlander",
    "Mitsubishi Outlander Sport (ASX)",
    "Mitsubishi Eclipse Cross",
    "Mitsubishi Mirage",
    "Mitsubishi Galant", // Older model
    "Mitsubishi Lancer", // Older model
    "Mitsubishi Lancer Evolution", // Performance model
    "Mitsubishi Pajero",
    "Mitsubishi Montero", // In some markets
    "Mitsubishi RVR", // Also known as ASX in some regions
    "Mitsubishi i-MiEV", // Electric model
    "Mitsubishi 3000GT", // Classic sports car
    "Mitsubishi Mighty Max", // Older truck model
    "Mitsubishi Eclipse", // Older sports coupe
  ],

  isuzuModels: [
    "Isuzu D-Max",
    "Isuzu MU-X",
    "Isuzu Trooper", // Older SUV model
    "Isuzu Rodeo", // Older SUV model
    "Isuzu Ascender", // Older SUV model
    "Isuzu Amigo", // Older compact SUV
    "Isuzu Hombre", // Compact pickup, older model
    "Isuzu NPR", // Medium-duty truck
    "Isuzu N-Series", // Commercial trucks
    "Isuzu F-Series", // Heavy-duty trucks
    "Isuzu Elf", // Light-duty truck
    "Isuzu Wizard", // Older SUV model
    "Isuzu Bellett", // Classic sedan
  ],
  
  landRoverModels: [
    "Land Rover Defender",
    "Land Rover Discovery",
    "Land Rover Discovery Sport",
    "Land Rover Range Rover",
    "Land Rover Range Rover Sport",
    "Land Rover Range Rover Velar",
    "Land Rover Range Rover Evoque",
    "Land Rover Freelander", // Older model
    "Land Rover Series I", // Classic model
    "Land Rover Series II", // Classic model
    "Land Rover Series III", // Classic model
    "Land Rover LR2", // Older model
    "Land Rover LR3", // Older model
    "Land Rover LR4", // Older model
  ],
  
  cadillacModels: [
    "Cadillac Escalade",
    "Cadillac XT4",
    "Cadillac XT5",
    "Cadillac XT6",
    "Cadillac CT4",
    "Cadillac CT5",
    "Cadillac CT6",
    "Cadillac ATS", // Older model
    "Cadillac CTS", // Older model
    "Cadillac SRX", // Older model
    "Cadillac STS", // Older model
    "Cadillac XTS", // Older model
    "Cadillac DeVille", // Classic model
    "Cadillac Eldorado", // Classic model
    "Cadillac Fleetwood", // Classic model
    "Cadillac Brougham", // Classic model
  ],
  
  porscheModels: [
    "Porsche 911",
    "Porsche 718 Cayman",
    "Porsche 718 Boxster",
    "Porsche Panamera",
    "Porsche Macan",
    "Porsche Cayenne",
    "Porsche Taycan",
    "Porsche 944", // Older model
    "Porsche 968", // Older model
    "Porsche 928", // Classic model
    "Porsche Carrera GT", // Supercar
    "Porsche 356", // Classic model
    "Porsche 917", // Classic racing model
    "Porsche Boxster", // Older model
  ],
  
  audiModels: [
    "Audi A1",
    "Audi A3",
    "Audi A4",
    "Audi A5",
    "Audi A6",
    "Audi A7",
    "Audi A8",
    "Audi Q2",
    "Audi Q3",
    "Audi Q4 e-tron",
    "Audi Q5",
    "Audi Q7",
    "Audi Q8",
    "Audi TT",
    "Audi R8",
    "Audi S1", // Sport model
    "Audi S3", // Sport model
    "Audi S4", // Sport model
    "Audi S5", // Sport model
    "Audi S6", // Sport model
    "Audi S7", // Sport model
    "Audi S8", // Sport model
    "Audi RS3", // Performance model
    "Audi RS4", // Performance model
    "Audi RS5", // Performance model
    "Audi RS6", // Performance model
    "Audi RS7", // Performance model
    "Audi Q5 Sportback", // SUV variant
    "Audi A3 Sportback", // Hatchback variant
  ],
  
  suzukiModels: [
    "Suzuki Jimny",
    "Suzuki Vitara",
    "Suzuki S-Cross",
    "Suzuki Swift",
    "Suzuki Baleno",
    "Suzuki Alto",
    "Suzuki Ertiga",
    "Suzuki Celerio",
    "Suzuki SX4",
    "Suzuki Grand Vitara", // Older model
    "Suzuki Forenza", // Older model
    "Suzuki Kizashi", // Older model
    "Suzuki Wagon R",
    "Suzuki Swift Sport", // Sport model
    "Suzuki Equator", // Older model (pickup)
    "Suzuki Cappuccino", // Classic sports car
  ],
  
  infinitiModels: [
    "Infiniti Q50",
    "Infiniti Q60",
    "Infiniti Q70",
    "Infiniti Q80 Inspiration", // Concept model
    "Infiniti QX50",
    "Infiniti QX55",
    "Infiniti QX60",
    "Infiniti QX80",
    "Infiniti G35", // Older model
    "Infiniti G37", // Older model
    "Infiniti FX35", // Older model
    "Infiniti FX50", // Older model
    "Infiniti M35", // Older model
    "Infiniti M37", // Older model
    "Infiniti JX35", // Older model
  ],
  
  hummerModels: [
    "Hummer H1",
    "Hummer H2",
    "Hummer H3",
    "Hummer H3T", // Pickup version of H3
    "Hummer EV", // Electric model
  ],
  
  lincolnModels: [
    "Lincoln Navigator",
    "Lincoln Aviator",
    "Lincoln Corsair",
    "Lincoln Nautilus",
    "Lincoln Continental", // Older model
    "Lincoln MKC", // Older model
    "Lincoln MKS", // Older model
    "Lincoln MKT", // Older model
    "Lincoln MKX", // Older model
    "Lincoln Town Car", // Classic model
    "Lincoln LS", // Older model
    "Lincoln Zephyr", // Classic model
    "Lincoln Model L", // Classic model
  ],
  
  volkswagenModels: [
    "Volkswagen Golf",
    "Volkswagen Jetta",
    "Volkswagen Passat",
    "Volkswagen Arteon",
    "Volkswagen Tiguan",
    "Volkswagen ID.4", // Electric model
    "Volkswagen ID.3", // Electric model
    "Volkswagen Beetle", // Classic model
    "Volkswagen Polo",
    "Volkswagen Atlas",
    "Volkswagen Touareg",
    "Volkswagen Scirocco", // Older model
    "Volkswagen Corrado", // Classic model
    "Volkswagen Rabbit", // Older model (North America)
    "Volkswagen Sharan",
    "Volkswagen Transporter", // Van model
  ],
  
  daihatsuModels: [
    "Daihatsu Terios",
    "Daihatsu Rocky",
    "Daihatsu Ayla",
    "Daihatsu Sirion",
    "Daihatsu Mira",
    "Daihatsu Cuore",
    "Daihatsu Gran Max",
    "Daihatsu Hijet",
    "Daihatsu Charade", // Older model
    "Daihatsu Applause", // Older model
    "Daihatsu Max", // Older model
    "Daihatsu Materia", // Older model
    "Daihatsu Delta",
  ],
  
  mercuryModels: [
    "Mercury Grand Marquis",
    "Mercury Mountaineer",
    "Mercury Mariner",
    "Mercury Milan",
    "Mercury Sable",
    "Mercury Cougar",
    "Mercury Mystique",
    "Mercury Villager",
    "Mercury Comet", // Classic model
    "Mercury Capri", // Classic model
    "Mercury Marauder", // Classic model
    "Mercury Montego", // Older model
    "Mercury Tracer", // Older model
    "Mercury Zephyr", // Older model
  ],

  volvoModels: [
    "Volvo S60",
    "Volvo S90",
    "Volvo V60",
    "Volvo V90",
    "Volvo XC40",
    "Volvo XC60",
    "Volvo XC90",
    "Volvo C30", // Older model
    "Volvo C70", // Older model
    "Volvo S40", // Older model
    "Volvo S70", // Older model
    "Volvo V70", // Older model
    "Volvo V40", // Older model
    "Volvo 240", // Classic model
    "Volvo 850", // Classic model
  ],
  
  peugeotModels: [
    "Peugeot 208",
    "Peugeot 2008",
    "Peugeot 301",
    "Peugeot 308",
    "Peugeot 3008",
    "Peugeot 508",
    "Peugeot 5008",
    "Peugeot Partner",
    "Peugeot Expert",
    "Peugeot Boxer",
    "Peugeot 206", // Older model
    "Peugeot 207", // Older model
    "Peugeot 407", // Older model
    "Peugeot 508 SW", // Station wagon variant
    "Peugeot 4007", // SUV model
    "Peugeot 607", // Older model
    "Peugeot 805", // Older model
  ],
  
  bentleyModels: [
    "Bentley Continental GT",
    "Bentley Continental GTC",
    "Bentley Flying Spur",
    "Bentley Bentayga",
    "Bentley Mulsanne", // Older model
    "Bentley Arnage", // Classic model
    "Bentley Brooklands", // Classic model
    "Bentley Azure", // Classic model
    "Bentley Turbo R", // Classic model
    "Bentley Eight", // Classic model
    "Bentley R-Type", // Classic model
    "Bentley S1", // Classic model
    "Bentley Speed Six", // Classic model
  ],
  
  jaguarModels: [
    "Jaguar F-Type",
    "Jaguar F-PACE",
    "Jaguar E-PACE",
    "Jaguar XE",
    "Jaguar XF",
    "Jaguar XJ", // Older model
    "Jaguar XK", // Older model
    "Jaguar S-Type", // Older model
    "Jaguar X-Type", // Older model
    "Jaguar I-PACE", // Electric model
    "Jaguar D-Type", // Classic racing model
    "Jaguar E-Type", // Classic model
    "Jaguar XJ220", // Classic supercar
  ],
  
  subaruModels: [
    "Subaru Outback",
    "Subaru Forester",
    "Subaru Crosstrek",
    "Subaru Impreza",
    "Subaru Legacy",
    "Subaru Ascent",
    "Subaru WRX",
    "Subaru WRX STI",
    "Subaru BRZ",
    "Subaru Baja", // Older model
    "Subaru Tribeca", // Older model
    "Subaru SVX", // Classic model
    "Subaru 360", // Classic model
    "Subaru Loyale", // Older model
    "Subaru Justy", // Older model
  ],
  
  zxautoModels: [
    "ZXAuto Landwind",
    "ZXAuto JMC",
    "ZXAuto Coolbear",
    "ZXAuto Aoxin",
    "ZXAuto ZS",
    "ZXAuto Eado",
    "ZXAuto Tana",
    "ZXAuto Huoyun",
    "ZXAuto T8",
    "ZXAuto Dadi",
  ],
  
  changanModels: [
    "Changan CS35",
    "Changan CS55",
    "Changan CS75",
    "Changan CS95",
    "Changan Eado",
    "Changan Alsvin",
    "Changan Hunter",
    "Changan Van",
    "Changan CX70",
    "Changan Benni",
    "Changan Raeton",
    "Changan CS15",
    "Changan Kaicheng",
    "Changan A800",
  ],
  
  renaultModels: [
    "Renault Clio",
    "Renault Captur",
    "Renault Megane",
    "Renault Koleos",
    "Renault Kadjar",
    "Renault Arkana",
    "Renault Talisman",
    "Renault Zoe", // Electric model
    "Renault Espace",
    "Renault Laguna", // Older model
    "Renault Scenic",
    "Renault Trafic",
    "Renault Kangoo",
    "Renault 5", // Classic model
    "Renault 12", // Classic model
  ],
  
  buickModels: [
    "Buick Enclave",
    "Buick Encore",
    "Buick Encore GX",
    "Buick LaCrosse", // Older model
    "Buick Regal", // Older model
    "Buick Verano", // Older model
    "Buick Cascada", // Older model
    "Buick Century", // Older model
    "Buick Electra", // Classic model
    "Buick Skylark", // Classic model
    "Buick Riviera", // Classic model
    "Buick Roadmaster", // Classic model
    "Buick Terraza", // Older model
    "Buick Rainier", // Older model
    "Buick Lucerne", // Older model
  ],
  
  maseratiModels: [
    "Maserati Ghibli",
    "Maserati Levante",
    "Maserati Quattroporte",
    "Maserati Alfieri", // Upcoming model
    "Maserati GranTurismo",
    "Maserati GranCabrio",
    "Maserati Khamsin", // Classic model
    "Maserati Bora", // Classic model
    "Maserati Biturbo", // Older model
    "Maserati 3200 GT", // Classic model
    "Maserati Mistral", // Classic model
    "Maserati Sebring", // Classic model
  ],
  
  rollsRoyceModels: [
    "Rolls-Royce Phantom",
    "Rolls-Royce Ghost",
    "Rolls-Royce Cullinan",
    "Rolls-Royce Wraith",
    "Rolls-Royce Dawn",
    "Rolls-Royce Silver Shadow", // Classic model
    "Rolls-Royce Silver Spur", // Classic model
    "Rolls-Royce Silver Cloud", // Classic model
    "Rolls-Royce Corniche", // Classic model
    "Rolls-Royce Phantom Coupe", // Older model
    "Rolls-Royce Phantom Drophead Coupe", // Older model
    "Rolls-Royce 20/25 HP", // Classic model
    "Rolls-Royce Silver Seraph", // Older model
    "Rolls-Royce Park Ward", // Classic model
  ],
  
  lamborghiniModels: [
    "Lamborghini Huracán",
    "Lamborghini Aventador",
    "Lamborghini Urus",
    "Lamborghini Gallardo", // Older model
    "Lamborghini Murciélago", // Older model
    "Lamborghini Diablo", // Classic model
    "Lamborghini Countach", // Classic model
    "Lamborghini Miura", // Classic model
    "Lamborghini Sian", // Hybrid model
    "Lamborghini Centenario", // Limited edition
    "Lamborghini Veneno", // Limited edition
    "Lamborghini Reventón", // Limited edition
    "Lamborghini Jarama", // Classic model
    "Lamborghini Islero", // Classic model
  ],
  
  ferrariModels: [
    "Ferrari 488 GTB",
    "Ferrari 488 Spider",
    "Ferrari F8 Tributo",
    "Ferrari F8 Spider",
    "Ferrari Roma",
    "Ferrari Portofino M",
    "Ferrari 812 Superfast",
    "Ferrari 812 GTS",
    "Ferrari LaFerrari", // Hybrid supercar
    "Ferrari Enzo", // Classic model
    "Ferrari F40", // Classic model
    "Ferrari F50", // Classic model
    "Ferrari 355", // Older model
    "Ferrari 360 Modena", // Older model
    "Ferrari Testarossa", // Classic model
    "Ferrari Dino", // Classic model
  ],
  
  citroenModels: [
    'Citroën C1',
    'Citroën C3',
    'Citroën C4',
    'Citroën C5',
    'Citroën C6',
    'Citroën C3 Aircross',
    'Citroën C5 Aircross',
    'Citroën Berlingo',
    'Citroën Jumpy',
    'Citroën Jumper',
    'Citroën DS3',
    'Citroën DS4',
    'Citroën DS5',
    'Citroën AX',
    'Citroën BX',
    'Citroën ZX',
    'Citroën Saxo',
    'Citroën Nemo',
    'Citroën SpaceTourer'
  ],
  
  seatModels: [
    'SEAT Ibiza',
    'SEAT León',
    'SEAT Ateca',
    'SEAT Arona',
    'SEAT Tarraco',
    'SEAT Mii',
    'SEAT Alhambra',
    'SEAT Cordoba',
    'SEAT Toledo',
    'SEAT Exeo',
    'SEAT Cupra Ateca',
    'SEAT Cupra León',
    'SEAT Cupra Formentor',
    'SEAT León Sportstourer',
    'SEAT Altea',
    'SEAT Altea XL',
    'SEAT Marbella',
    'SEAT 124',
    'SEAT 1430'
  ],
  
  saabModels: [
    'SAAB 92',
    'SAAB 93',
    'SAAB 95',
    'SAAB 96',
    'SAAB 99',
    'SAAB 900',
    'SAAB 9000',
    'SAAB 9-3',
    'SAAB 9-5',
    'SAAB 9-4X',
    'SAAB 9-7X',
    'SAAB 900 Turbo',
    'SAAB 9-3 Turbo',
    'SAAB 9-5 Aero',
    'SAAB Sonett',
    'SAAB 9000 CSE',
    'SAAB 9-3 SportCombi',
    'SAAB 9-5 SportCombi'
  ],
  
  daewooModels: [
    'Daewoo Matiz',
    'Daewoo Lanos',
    'Daewoo Nubira',
    'Daewoo Leganza',
    'Daewoo Tacuma',
    'Daewoo Kalos',
    'Daewoo Evanda',
    'Daewoo Magnus',
    'Daewoo Racer',
    'Daewoo Korando',
    'Daewoo Espero',
    'Daewoo Nexia',
    'Daewoo Matiz Creative',
    'Daewoo Tico',
    'Daewoo Prince'
  ],
  
  skodaModels: [
    'Škoda Fabia',
    'Škoda Octavia',
    'Škoda Superb',
    'Škoda Kodiaq',
    'Škoda Karoq',
    'Škoda Scala',
    'Škoda Kamiq',
    'Škoda Citigo',
    'Škoda Rapid',
    'Škoda Roomster',
    'Škoda Yeti',
    'Škoda 1000 MB',
    'Škoda 120',
    'Škoda 135/136',
    'Škoda 100/110'
  ],
  
  opelModels: [
    'Opel Astra',
    'Opel Corsa',
    'Opel Insignia',
    'Opel Mokka',
    'Opel Zafira',
    'Opel Grandland',
    'Opel Adam',
    'Opel Meriva',
    'Opel Combo',
    'Opel Astra K',
    'Opel Vectra',
    'Opel Antara',
    'Opel GTC',
    'Opel Karl',
    'Opel Frontera',
    'Opel Kadett',
    'Opel Movano',
    'Opel Omega',
    'Opel Signum'
  ],
  
  lynkCoModels: [
    'Lynk & Co 01',
    'Lynk & Co 02',
    'Lynk & Co 03',
    'Lynk & Co 04',
    'Lynk & Co 05',
    'Lynk & Co 06'
  ],

  tankModels: [
    'Tank 300',
    'Tank 500',
    'Tank 700',
    'Tank 800'
  ],
  
  smartModels: [
    'Smart Fortwo',
    'Smart Forfour',
    'Smart Roadster',
    'Smart Cabrio',
    'Smart EQ Fortwo',
    'Smart EQ Forfour'
  ],
  
  hongqiModels: [
    'Hongqi H5',
    'Hongqi H7',
    'Hongqi H9',
    'Hongqi L5',
    'Hongqi L7',
    'Hongqi E-HS9',
    'Hongqi HS7',
    'Hongqi HS5'
  ],
  
  zotyeModels: [
    'Zotye T300',
    'Zotye T500',
    'Zotye T700',
    'Zotye Z100',
    'Zotye Z300',
    'Zotye Z8',
    'Zotye SR7',
    'Zotye T600'
  ],
  mahindraModels: [
    'Mahindra Thar',
    'Mahindra XUV300',
    'Mahindra XUV500',
    'Mahindra XUV700',
    'Mahindra Scorpio',
    'Mahindra Bolero',
    'Mahindra Alturas G4',
    'Mahindra KUV100',
    'Mahindra TUV300',
    'Mahindra Marazzo',
    'Mahindra eVerito',
    'Mahindra eKUV100'
  ],

  soueastModels: [
    'Soueast DX3',
    'Soueast DX7',
    'Soueast V3',
    'Soueast V5',
    'Soueast T5',
    'Soueast Fada',
    'Soueast JX3'
  ],

  ineosModels: ['Ineos Grenadier'],

  lucidModels: [
    'Lucid Air',
    'Lucid Air Pure',
    'Lucid Air Touring',
    'Lucid Air Grand Touring',
    'Lucid Air Dream Edition'
  ],

  teslaModels: [
    'Tesla Model S',
    'Tesla Model 3',
    'Tesla Model X',
    'Tesla Model Y',
    'Tesla Roadster',
    'Tesla Cybertruck'
  ],

  exeedModels: [
    'Exeed TX',
    'Exeed VX',
    'Exeed LX',
    'Exeed E01'
  ],

  dongfengModels: [
    'Dongfeng Fengon 5',
    'Dongfeng Fengon 6',
    'Dongfeng H30',
    'Dongfeng S30',
    'Dongfeng AX7',
    'Dongfeng Ruiyi',
    'Dongfeng EQ',
    'Dongfeng D60',
    'Dongfeng KX',
    'Dongfeng Rich'
  ],

  baicModels: [
    'BAIC X25',
    'BAIC X35',
    'BAIC X55',
    'BAIC Senova D20',
    'BAIC Senova D50',
    'BAIC BJ40',
    'BAIC BJ80',
    'BAIC E-series',
    'BAIC M-series'
  ],

  jacModels: [
    'JAC S2',
    'JAC S3',
    'JAC S5',
    'JAC S7',
    'JAC Refine',
    'JAC iEV',
    'JAC T6',
    'JAC T8',
    'JAC J5',
    'JAC J7',
    'JAC E-segment'
  ],

  mclarenModels: [
    'McLaren F1',
    'McLaren P1',
    'McLaren 570S',
    'McLaren 570GT',
    'McLaren 600LT',
    'McLaren 720S',
    'McLaren Artura',
    'McLaren Sabre',
    'McLaren Elva',
    'McLaren MP4-12C',
    'McLaren MP4-650S',
    'McLaren GT'
  ],

  maxusModels: [
    'Maxus G10',
    'Maxus T60',
    'Maxus D90',
    'Maxus Mifa 9',
    'Maxus V80',
    'Maxus G50',
    'Maxus T90'
  ],

  lifanModels: [
    'Lifan 320',
    'Lifan 330',
    'Lifan 520',
    'Lifan 620',
    'Lifan X60',
    'Lifan X70',
    'Lifan X80',
    'Lifan Murman'
  ],

  victoryAutoModels: [
    'Victory Auto V1',
    'Victory Auto V2',
    'Victory Auto V3',
    'Victory Auto V5'
  ],

  fotonModels: [
    'Foton Tunland',
    'Foton View CS2',
    'Foton Auman',
    'Foton Ollin',
    'Foton Gratour',
    'Foton Thunder',
    'Foton Forland',
    'Foton S50'
  ],

  cmcModels: [
    'CMC T5',
    'CMC T10',
    'CMC D6',
    'CMC D9',
    'CMC G10',
    'CMC G6'
  ],

  jetourModels: [
    'Jetour X70',
    'Jetour X90',
    'Jetour Dashing',
    'Jetour X70 Coupe',
    'Jetour T2',
    'Jetour X70S'
  ],

  jmcModels: [
    'JMC Baodian',
    'JMC Yuhu',
    'JMC Teshun',
    'JMC Vigus',
    'JMC 4X4 Pickup',
    'JMC Jinma'
  ],

  tataModels: [
    'Tata Nano',
    'Tata Tiago',
    'Tata Tigor',
    'Tata Altroz',
    'Tata Nexon',
    'Tata Harrier',
    'Tata Safari',
    'Tata Punch',
    'Tata Hexa',
    'Tata Bolt',
    'Tata Zest',
    'Tata Indica',
    'Tata Aria'
  ],

  alfaRomeoModels: ['GIULIA', 'GIULETTA', 'STELVIO'],

  bydCarNames: [
    'Han EV',
    'Tang EV',
    'Song Plus EV',
    'Qin Plus EV',
    'e6',
    'Dolphin',
    'F3',
    'S2',
    'T3',
    'ATTO 3',
    'Yuan EV',
    'L3',
    'F0',
    'S6',
  ],

  fawCarNames: [
    'Besturn B50',
    'Besturn T77',
    'FAW J7',
    'FAW J6',
    'FAW Oley',
    'FAW Xiali',
    'Hongqi H5',
    'Hongqi H7',
    'Hongqi E-HS3',
    'Jiefang CA141',
  ],

  greatWallCarNames: [
    'Haval H6',
    'Haval F7',
    'Haval Jolion',
    'Wingle 7',
    'P-Series',
    'Tank 300',
    'Ora Black Cat',
    'Ora White Cat',
    'Great Wall Pickup',
    'Great Wall Steed',
  ],

  gacCarNames: [
    'GAC Trumpchi GS4',
    'GAC Trumpchi GS5',
    'GAC Trumpchi GS8',
    'GAC Trumpchi EMKOO',
    'GAC Trumpchi M6',
    'GAC Trumpchi GM6',
    'GAC Aion S',
    'GAC Aion V',
    'GAC Aion LX',
    'GAC GA8',
  ],

  havalCarNames: [
    'Haval H6',
    'Haval H9',
    'Haval F7',
    'Haval F5',
    'Haval Jolion',
    'Haval H2',
    'Haval H8',
    'Haval Big Dog',
    'Haval Dargo',
    'Haval H6 Plug-in Hybrid',
  ],

  protonCarNames: [
    'Proton Saga',
    'Proton Persona',
    'Proton Iriz',
    'Proton X50',
    'Proton X70',
    'Proton Exora',
    'Proton Preve',
    'Proton Waja',
    'Proton Wira',
    'Proton Savvy',
  ],

  astonMartinCarNames: [
    'Aston Martin DB11',
    'Aston Martin Vantage',
    'Aston Martin DBX',
    'Aston Martin DBS Superleggera',
    'Aston Martin Rapide',
    'Aston Martin Virage',
    'Aston Martin DB9',
    'Aston Martin One-77',
    'Aston Martin Valhalla',
    'Aston Martin DBR9',
  ],

  ssangYongCarNames: [
    'SsangYong Tivoli',
    'SsangYong Korando',
    'SsangYong Rexton',
    'SsangYong Musso',
    'SsangYong Kyron',
    'SsangYong Stavic',
    'SsangYong XLV',
    'SsangYong Chairman',
    'SsangYong Rodius',
    'SsangYong Actyon',
  ],

  fiatCarNames: [
    'Fiat 500',
    'Fiat Panda',
    'Fiat Tipo',
    'Fiat 124 Spider',
    'Fiat 500L',
    'Fiat Qubo',
    'Fiat Doblo',
    'Fiat Punto',
    'Fiat Stilo',
    'Fiat Bravo',
  ],

  saabCarNames: [
    'Saab 900',
    'Saab 9000',
    'Saab 9-3',
    'Saab 9-5',
    'Saab 9-7X',
    'Saab 96',
    'Saab 93',
    'Saab 9-2X',
    'Saab Sonett',
    'Saab 99',
  ],

  seatCarNames: [
    'SEAT Ibiza',
    'SEAT Leon',
    'SEAT Ateca',
    'SEAT Arona',
    'SEAT Tarraco',
    'SEAT Alhambra',
    'SEAT Mii',
    'SEAT Toledo',
    'SEAT Exeo',
    'SEAT Leon Cupra',
  ],

  // carsTypeList: [
  //   "Toyota",
  //   'Hyundai',
  //   'Ford',
  //   'Kia',
  //   'Lexus',
  //   'Honda',
  //   'Mazda',
  //   'Chevrolet',
  //   'Parts & Accessories',
  //   'Nissan',
  //   'Geely',
  //   'Chery',
  //   'MG',
  //   'Genesis',
  //   'GMC',
  //   'Trucks and heavy equipment',
  //   'Mercedes',
  //   'BMW',
  //   'Motorcycles',
  //   'Dodge',
  //   'Chrysler',
  //   'Jeep',
  //   'Mitsubishi',
  //   'Isuzu',
  //   'Land Rover',
  //   'Cadillac',
  //   'Porsche',
  //   'Audi',
  //   'Suzuki',
  //   'infinity',
  //   'Hummer',
  //   'Lincoln',
  //   'Volkswagen',
  //   'Daihatsu',
  //   'Mercury',
  //   'Volvo',
  //   'Peugeot',
  //   'Bently',
  //   "Jaguar",
  //   'Subaru',
  //   'ZXAUTO',
  //   'Changan',
  //   'Renault',
  //   'Buick',
  //   'Maserati',
  //   'Rolls-Royce',
  //   'Lamborghini',
  //   'Ferrari',
  //   'Citroen',
  //   'Seat',
  //   'SABB',
  //   'Fiat',
  //   'SsangYong',
  //   'Aston Martin',
  //   'Proton',
  //   'Haval',
  //   'GAC',
  //   'Great Wall',
  //   'FAW',
  //   'BYD',
  //   'Alfa Romeo',
  //   'TATA',
  //   'JMC',
  //   'JETOUR',
  //   "CMC",
  //   'Foton',
  //   'VICTORY AUTO',
  //   'Lifan',
  //   'Maxus',
  //   'McLaren',
  //   'JAC',
  //   'Baic',
  //   'Dongfeng',
  //   'EXEED',
  //   'Tesla',
  //   'Lucid',
  //   'INEOS',
  //   'Soueaste',
  //   'Mahindra',
  //   'Zotye',
  //   'Hongqi',
  //   'SMART',
  //   'Tank',
  //   'Lynk & Co',
  //   'Opel',
  //   'Skoda',
  //   'Daewoo',
  // ],

  yearsList: [
    "1985",
    "1986",
    "1987",
    "1988",
    "1989",
    "1990",
    "1991",
    "1992",
    "1993",
    "1994",
    "1995",
    "1996",
    "1997",
    "1998",
    "1999",
    "2000",
    "2001",
    "2002",
    "2003",
    "2004",
    "2005",
    "2006",
    "2007",
    "2008",
    "2009",
    "2010",
    "2011",
    "2012",
    "2013",
    "2014",
    "2015",
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    '2025'
  ].reverse(),

  yearsListWithAll: [
    "1985",
    "1986",
    "1987",
    "1988",
    "1989",
    "1990",
    "1991",
    "1992",
    "1993",
    "1994",
    "1995",
    "1996",
    "1997",
    "1998",
    "1999",
    "2000",
    "2001",
    "2002",
    "2003",
    "2004",
    "2005",
    "2006",
    "2007",
    "2008",
    "2009",
    "2010",
    "2011",
    "2012",
    "2013",
    "2014",
    "2015",
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    '2025',
    "all"
  ].reverse(),

  motorcycleModels: [
    'Harley-Davidson Sportster',
    'Harley-Davidson Softail',
    'Harley-Davidson Road King',
    'Harley-Davidson Fat Boy',
    'Yamaha YZF-R1',
    'Yamaha MT-07',
    'Yamaha FZ-09',
    'Yamaha VMAX',
    'Kawasaki Ninja ZX-10R',
    'Kawasaki Z900',
    'Kawasaki Versys 650',
    'Kawasaki KLR650',
    'Ducati Panigale V4',
    'Ducati Monster 1200',
    'Ducati Multistrada V4',
    'Ducati Scrambler Icon',
    'Honda CB650R',
    'Honda CBR600RR',
    'Honda CRF1100L Africa Twin',
    'Honda Gold Wing',
    'Suzuki GSX-R750',
    'Suzuki Hayabusa',
    'Suzuki V-Strom 650',
    'Suzuki SV650',
    'BMW R1250GS',
    'BMW S1000RR',
    'BMW F850GS',
    'BMW R18',
    'Triumph Bonneville T120',
    'Triumph Street Triple RS',
    'Triumph Tiger 900',
    'Triumph Thruxton RS',
    'KTM 390 Duke',
    'KTM RC 390',
    'KTM 1290 Super Duke R',
    'KTM 690 Enduro R',
    'Indian Scout',
    'Indian Chief',
    'Indian FTR 1200',
    'Indian Challenger',
    'Moto Guzzi V7 III',
    'Moto Guzzi California Touring 1400',
    'Aprilia RS 660',
    'Aprilia Tuono V4',
    'Royal Enfield Interceptor 650',
    'Royal Enfield Himalayan',
    'Bajaj Dominar 400',
    'Husqvarna Vitpilen 701',
    'Benelli Leoncino 500',
  ],

  realStateSpacialTypes: ["rent", "sale"],

  realStateRentTypes: [
    'Apartment for rent',
    'Villas for rent',
    'Lands for rent',
    'Shops for rent',
    'Offices for rent',
    'Chalets for rent',
    'Camps for rent',
    'Hall for rent',
    'Warehouses for rent',
    'Building for rent',
    'Compound for rent',
    'Rooms for rent',
    'Houses for rent',
    'Floors Through for rent',
  ],

  realEstateSaleTypeList: [
    'Apartment for sale',
    'Villas for sale',
    'Lands for sale',
    'Shops for sale',
    'Offices for sale',
    'Chalet for sale',
    'Camps for sale',
    'Halls for sale',
    'Warehouses for sale',
    'Building for sale',
    'Commercial Land for sale',
    'Farms for sale',
    'Floors Through for sale',
    'Compound for sale',
    'Houses for sale',
  ],

  locationsMap: {
    "Amman": [
      "Downtown Amman",
      "Jabal Amman",
      "Abdoun",
      "Sweifieh",
      "Khalda",
      "Shmeisani",
      "Jabal Al-Weibdeh",
      "Tla' Al-Ali",
      "Dabouq",
      "Marj Al-Hamam",
      "Al-Rabiah",
      "Al-Jubeiha",
      "Al-Bayader",
      "Mecca Street",
      "Abu Nseir",
      "Deir Ghbar",
      "Al-Muqabalain",
      "Sahab",
      "Naur",
    ],
    "Zarqa": [
      "Zarqa City",
      "New Zarqa",
      "Zarqa Camp",
      "Russeifa",
      "Hashemiyeh",
      "Azraq",
      "Birayn",
    ],
    "Irbid": [
      "Irbid City",
      "Downtown Irbid",
      "Bani Kinanah",
      "Beit Ras",
      "Hakama",
      "Al-Mazar Al-Shamali",
      "Taybeh",
    ],
    "Ajloun": [
      "Ajloun City",
      "Anjara",
      "Kufranjah",
      "Sakhrah",
      "Rasoun",
      "Ain Janna",
    ],
    "Jerash": [
      "Jerash City",
      "Suf",
      "Sakib",
      "Al-Mastaba",
      "Burma",
    ],
    "Mafraq": [
      "Mafraq City",
      "Khaldiya",
      "Safawi",
      "Ruweished",
      "Um Al-Jimal",
      "Al-Salhiyah",
    ],
    "Balqa": [
      "Salt City",
      "Fuheis",
      "Mahis",
      "Ain Al-Basha",
      "Yarqa",
      "Wadi Shueib",
      "Zay",
    ],
    "Karak": [
      "Karak City",
      "Al-Mazar",
      "Ad-Dhahirah",
      "Ghor Al-Safi",
      "Faqqu",
      "Al-Rabba",
    ],
    "Tafilah": [
      "Tafilah City",
      "Busaira",
      "Qadesiah",
      "Al-Hasa",
      "Dana",
    ],
    "Ma'an": [
      "Ma'an City",
      "Al-Husseinieh",
      "Al-Jafr",
      "Al-Mudawara",
    ],
    "Aqaba": [
      "Aqaba City",
      "Wadi Araba",
      "Quairah",
      "Ras Al-Naqab",
      "South Beach",
    ],
    "Madaba": [
      "Madaba City",
      "Ma'in",
      "Mount Nebo Area",
      "Libb",
      "Dhiban",
      "Al-Fayha",
    ],
    "Ramtha": [
      "Ramtha City",
      "Al-Turra",
      "Al-Sarih",
    ],
    "Al-Husn": [
      "Al-Husn City",
      "Al-Sadaqa",
      "Al-Khass",
      "Al-Karak Governorate",
    ],
    "Shoubak": [
      "Shoubak City",
      "Maan City",
      "Al-Sahel",
    ],
    "Wadi Musa": [
      "Wadi Musa",
      "Petra",
      "Umm Sayhoun",
      "Al-Madbah",
    ],
    "Russeifa": [
      "Russeifa City",
      "Al-Mazraa",
      "Shada",
      "Al-Tour",
    ],
    "Ain Al-Basha": [
      "Ain Al-Basha City",
      "Al-Basha",
      "Wadi Al-Khandaq",
    ],
    "Fuheis": [
      "Fuheis City",
      "Wadi Al-Mana",
      "Wadi Al-Nahla",
    ],
    "Mahis": [
      "Mahis City",
      "Al-Taba",
      "Al-Khair",
      "Wadi Al-Batin",
    ],
    "Dhiban": [
      "Dhiban City",
      "Qasr Al-Azraq",
      "Al-Qadisiyah",
    ],
    "Mu'tah": [
      "Mu'tah City",
      "Al-Kherbit",
      "Al-Musharif",
      "Al-Khalidiyah",
    ],
    "Al-Salt": [
      "Al-Salt City",
      "Wadi Al-Bayadah",
      "Al-Muqabalain",
      "Khaled Bin Al-Walid",
      "Raghadan",
    ],
    "Al-Mafraq": [
      "Al-Mafraq City",
      "Al-Zaytoun",
      "Ruweished",
      "Al-Taybeh",
    ],
    "Al-Rusaifa": [
      "Al-Rusaifa City",
      "Al-Saada",
      "Al-Jowhara",
    ],
    "Al-Jubeiha": [
      "Al-Jubeiha City",
      "Al-Sahab",
      "Al-Karak",
    ],
    "Marj Al-Hamam": [
      "Marj Al-Hamam City",
      "Al-Hamra",
      "Qasr Al-Qusair",
    ],
    "Abdoun": [
      "Abdoun City",
      "Al-Tilal",
      "Jabal Al-Weibdeh",
    ],
    "Sweifieh": [
      "Sweifieh City",
      "Zahran",
      "Jabal Amman",
    ],
    "Khalda": [
      "Khalda City",
      "Al-Rabiah",
      "Al-Tal",
    ],
    "Tla' Al-Ali": [
      "Tla' Al-Ali City",
      "Al-Husayniya",
      "Al-Badr",
    ],
    "Dabouq": [
      "Dabouq City",
      "Al-Hussein",
      "Al-Nahda",
    ],
    "Deir Ghbar": [
      "Deir Ghbar City",
      "Jabal Al-Mukaber",
      "Wadi Al-Turfa",
    ],
    "Al-Muqabalain": [
      "Al-Muqabalain City",
      "Al-Muruj",
      "Al-Shaab",
    ],
    "Sahab": [
      "Sahab City",
      "Jabal Sahab",
      "Matar",
    ],
    "Naur": [
      "Naur City",
      "Al-Muqaibla",
      "Al-Dahab",
    ],
  }
}